import Tooltip from "./Tooltip";
import Info from "./Info";

const TooltipComposition = Object.assign(Tooltip, {
  Info,
});

export default TooltipComposition;
